import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { cn } from '@/lib/utils';
import { ROTULO_CONTRIBUINTE } from './destino';

export interface SeletorContribuinteProps {
  id: string;
  /** true = o destino e contribuinte de ICMS; false = nao contribuinte. */
  valor: boolean;
  onChange: (contribuinte: boolean) => void;
  disabled?: boolean;
  className?: string;
  /** Texto de ajuda logo abaixo do seletor (ex.: "Padrão: o cadastro do cliente"). */
  ajuda?: string;
}

/** Contribuinte de ICMS do destino (sim/nao). O padrao e definido por quem chama (origem, cadastro do cliente). */
export function SeletorContribuinte({ id, valor, onChange, disabled, className, ajuda }: SeletorContribuinteProps) {
  const valorTexto = valor ? 'sim' : 'nao';
  return (
    <>
      <Select value={valorTexto} onValueChange={(v) => onChange(v === 'sim')} disabled={disabled}>
        <SelectTrigger id={id} aria-label="Contribuinte de ICMS" aria-describedby={ajuda ? `${id}-ajuda` : undefined} className={cn('h-10 w-full rounded-[10px] bg-card', className)}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="sim">{ROTULO_CONTRIBUINTE.sim}</SelectItem>
          <SelectItem value="nao">{ROTULO_CONTRIBUINTE.nao}</SelectItem>
        </SelectContent>
      </Select>
      {ajuda && (
        <p id={`${id}-ajuda`} className="mt-1 text-caption text-ink-muted">
          {ajuda}
        </p>
      )}
    </>
  );
}
